(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/reducer.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/redux/reducer.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  CART_SET_PRODUCT,
  CART_APPEND_PRODUCT,
  CART_REMOVE_PRODUCT_GROUP,
  CART_CLEAR,
  CART_SET_ANIMATION_COMPLETE,
  CART_SET_ERROR,
  CART_CLEAR_ERROR
} = svs.tickets_giftshop.gift.giftform.cart.actiontypes;
const {
  KEY,
  DOMAIN
} = svs.tickets_giftshop.constants.cache;
const {
  MAX_TICKETS
} = svs.tickets_giftshop.constants.cart;
const {
  calculateCartSum,
  calculateNumberOfProductsInCart,
  appendProductToCart,
  setProductToCart
} = svs.tickets_giftshop.functions;
const cache = svs.components.Storage.browser.get(KEY, DOMAIN) || {};
const initCart = cache.cart || {};
const initState = _objectSpread({}, initCart);
function cartReducer() {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initState;
  let action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case CART_SET_ANIMATION_COMPLETE:
      {
        const {
          branding
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        const target = nextState[branding];
        if (target && target.cart) {
          const nextCart = target.cart.map(item => {
            const {
              productId,
              productVariation,
              type,
              skinId
            } = action.payload;
            if (item.product.productId === productId && item.product.productVariation === productVariation && item.product.type === type && item.product.skinId === skinId) {
              item.isAnimatingOnRender = false;
            }
            return item;
          });
          target.cart = nextCart;
        }
        return nextState;
      }
    case CART_CLEAR:
      {
        const {
          branding
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        const target = nextState[branding];
        if (target) {
          target.cart = [];
          target.sum = 0;
          target.count = 0;
          target.isFull = false;
          target.isError = false;
        }
        return nextState;
      }
    case CART_SET_PRODUCT:
      {
        const {
          amount,
          productId,
          productVariation,
          products,
          branding,
          type,
          skinId
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        if (!branding) return nextState;
        if (!nextState[branding]) {
          nextState[branding] = {};
        }
        const target = nextState[branding];
        const currentAmount = parseFloat(target.count);
        const currentCartProduct = _.find(target.cart, item => item.product.productId === productId && item.product.productVariation === productVariation && item.product.type === type && item.product.skinId === skinId);
        const currentCartProductAmount = currentCartProduct ? currentCartProduct.amount : 0;
        let nextAmount = parseFloat(amount);

        if (currentAmount + nextAmount - currentCartProductAmount > MAX_TICKETS && currentCartProductAmount < nextAmount) {
          nextAmount = MAX_TICKETS - currentAmount + currentCartProductAmount;
        }
        const nextCart = setProductToCart({
          cart: target.cart,
          productId,
          productVariation,
          type,
          products,
          amount: parseInt(nextAmount, 10),
          skinId
        });
        const nextCartLength = calculateNumberOfProductsInCart({
          cart: nextCart
        });
        target.cart = nextCart;
        target.sum = calculateCartSum({
          cart: nextCart
        });
        target.count = nextCartLength;
        target.isError = false;
        target.isFull = nextCartLength >= MAX_TICKETS;
        return nextState;
      }
    case CART_APPEND_PRODUCT:
      {
        const {
          productVariation,
          productId,
          products,
          branding,
          type,
          skinId
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        if (!branding) return nextState;
        if (!nextState[branding]) {
          nextState[branding] = {};
        }
        const target = nextState[branding];
        let nextCart;
        if (target.count >= MAX_TICKETS) {
          nextCart = target.cart;
        } else {
          nextCart = appendProductToCart({
            cart: target.cart,
            productId,
            productVariation,
            type,
            amount: 1,
            products,
            skinId
          });
        }
        const nextCartLength = calculateNumberOfProductsInCart({
          cart: nextCart
        });
        target.cart = nextCart;
        target.sum = calculateCartSum({
          cart: nextCart
        });
        target.count = nextCartLength;
        target.isFull = nextCartLength >= svs.tickets_giftshop.constants.cart.MAX_TICKETS;
        target.isError = false;
        return nextState;
      }
    case CART_REMOVE_PRODUCT_GROUP:
      {
        const {
          productId,
          productVariation,
          branding,
          type,
          skinId
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        const target = nextState[branding];
        if (target) {
          target.cart = [...target.cart.filter(_ref => {
            let {
              product
            } = _ref;
            return !(product.productId === productId && product.productVariation === productVariation && product.type === type && product.skinId === skinId);
          })];
          target.count = calculateNumberOfProductsInCart({
            cart: target.cart
          });
          target.sum = calculateCartSum({
            cart: target.cart
          });
          target.isFull = target.count >= svs.tickets_giftshop.constants.cart.MAX_TICKETS;
        }
        return nextState;
      }
    case CART_SET_ERROR:
      {
        const {
          branding
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        if (!branding) {
          return nextState;
        }
        if (nextState[branding]) {
          nextState[branding].isError = true;
        }
        return nextState;
      }
    case CART_CLEAR_ERROR:
      {
        const {
          branding
        } = action.payload;
        const nextState = JSON.parse(JSON.stringify(state));
        if (!branding || !nextState[branding]) {
          return nextState;
        }
        const target = nextState[branding];
        target.isError = false;
        return nextState;
      }
    default:
      return state;
  }
}
svs.tickets_giftshop.gift.giftform.cart.reducer = cartReducer;

 })(window);